module.exports = __webpack_public_path__ + "img/nothingOrange.9a41e057.png";